import { render, staticRenderFns } from "./ReadingList.vue?vue&type=template&id=d0180fd4&scoped=true&"
import script from "./ReadingList.vue?vue&type=script&lang=js&"
export * from "./ReadingList.vue?vue&type=script&lang=js&"
import style0 from "./ReadingList.vue?vue&type=style&index=0&id=d0180fd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0180fd4",
  null
  
)

export default component.exports